// config.js — same pattern as klonit-dashboard/src/config.js so .env values
// can be copied across without renaming. REACT_APP_ENV switches between
// "Development" and "Production"; backendURL is the DEFAULT export so
// `import backendURL from '../config'` matches the dashboard idiom.
const ENV = process.env.REACT_APP_ENV;

let backendURL;
let APPLICATION_URL;
let stripe_pub_key;

if (ENV === "Development") {
    backendURL = process.env.REACT_APP_BACKEND_URL_DEVELOPMENT;
    APPLICATION_URL = process.env.REACT_APP_APPLICATION_URL_DEVELOPMENT;
    stripe_pub_key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
} else if (ENV === "Production") {
    backendURL = process.env.REACT_APP_BACKEND_URL_PRODUCTION;
    APPLICATION_URL = process.env.REACT_APP_APPLICATION_URL_PRODUCTION;
    stripe_pub_key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
}

// Same named export as the dashboard (snake_case) so the Stripe Elements
// wrapper code reads the same in both apps.
const stripe_publishable_key = stripe_pub_key;

// --- localStorage keys (admin-scoped) ---
const STORAGE_TOKEN_KEY = 'klonit_admin_token';
const STORAGE_EMAIL_KEY = 'klonit_admin_email';

export default backendURL;
export {
    APPLICATION_URL,
    stripe_publishable_key,
    STORAGE_TOKEN_KEY,
    STORAGE_EMAIL_KEY,
};
